import React from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import infoSectionGameLogo from '../../../../assets/1x/mobile/infoSectionGameLogo.png';

const InfoSectionGameLogo = observer(() => {
  return (
    <Container x={270} y={64} name='InfoSectionGameLogo'>
      <Sprite anchor={0.5} image={infoSectionGameLogo} />
    </Container>
  );
});

export default InfoSectionGameLogo;
